import React, { useState } from 'react';
import {
	Box,
	Button,
	Heading,
	Input,
	VStack,
	useToast,
	FormControl,
	FormLabel,
	FormErrorMessage,
	Text,
	Image
} from '@chakra-ui/react';
import { gql, useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import c from "../../../constant";

const TWO_FACTOR_LOGIN = gql`
  mutation TwoFactorLogin($userId: String!, $code: String!, $onesignalUserId: String) {
    twoFactorLogin(userId: $userId, code: $code, onesignalUserId: $onesignalUserId) {
      accessToken
    }
  }
`;

const TwoFactorLogin = ({ userId, onesignalUserId = null }) => {
	const history = useHistory();
	const [code, setCode] = useState('');
	const [error, setError] = useState('');
	const { t } = useTranslation();

	const [twoFactorLogin, { loading }] = useMutation(TWO_FACTOR_LOGIN, {
		onCompleted: (data) => {
			const token = data.twoFactorLogin.accessToken;
			setError('');
			sessionStorage.setItem('accessToken', token);
			history.push('/');
		},
		onError: (error) => {
			const message =
				error.graphQLErrors?.[0]?.message || t('Login failed Please try again');
			setError(message);
		},
	});

	const handleSubmit = () => {
		if (code.length !== 6) {
			setError(t('Code must be 6 digits'));
			return;
		}

		twoFactorLogin({
			variables: {
				userId,
				code,
				onesignalUserId,
			},
		});
	};

	const handleChange = (e) => {
		// Remove all spaces from input
		const val = e.target.value.replace(/\s+/g, '');
		setCode(val);
		if (error) setError('');
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			handleSubmit();
		}
	};

	return (
		<Box bg="white" maxW="md" mx="auto" mt={10} p={6} borderWidth={c.borderRadius} boxShadow="sm">
			<VStack spacing={6} align="stretch">
				<Heading size="md" mt="0 !important">
					{t("Additional verification required")}
				</Heading>
				<Text>{t("Your account is protected with")} <b>multi-factor authentication (MFA)</b> .</Text>
				<Text mt={"0 !important"}>{t("To finish signing in, enter the code from your MFA device below")}</Text>
				<FormControl isInvalid={!!error}>
					<FormLabel>{t("MFA code")}</FormLabel>
					<Input
						autoFocus={true}
						placeholder=""
						maxLength={6}
						value={code}
						onChange={handleChange}
						onKeyDown={handleKeyDown}
						inputMode="numeric"
						pattern="[0-9]*"
						borderColor="gray.500"
						fontSize={18}
						color="#2980b9"
						fontWeight="bold"
					/>
					<FormErrorMessage>{t(error)}</FormErrorMessage>
				</FormControl>

				<Button
					colorScheme="blue"
					onClick={handleSubmit}
					isLoading={loading}
					isDisabled={code.length !== 6}
				>
					{t("Login")}
				</Button>
			</VStack>
		</Box>
	);
};

export default TwoFactorLogin;
